module.exports = __webpack_public_path__ + "img/ppt.f14d42dd.svg";